<template>
  <router-view />
</template>

<script>
export default {
  name: 'TheNotification'
};
</script>
